import { IDeleteProcessoRiscosUseCase } from "../../../presentation/useCases/delete/delete_processos_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteProcessoRiscosUseCase

export class DeleteProcessoRiscosUseCase implements IDeleteProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteProcessoRiscos( IdProcesso: number): Promise<void> {
    
    await this.repository.deleteProcessoRiscos( IdProcesso );
  }
}
